import { useDocumentMetadata } from '../../components/DocumentMetadataProvider';
export function useHubspotSyncFields(mappedMetadataIds) {
    const { data } = useDocumentMetadata();
    return data.properties
        .filter(({ property, pair }) => mappedMetadataIds.includes(property.id) && typeof pair.value === 'string' && pair.value !== '')
        .map(({ property, pair }) => ({
        id: property.id,
        label: property.label,
        value: pair.value,
    }));
}
